import { render, staticRenderFns } from "./fbq.vue?vue&type=template&id=cb59c4f8&"
import script from "./fbq.vue?vue&type=script&lang=js&"
export * from "./fbq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports